export default __webpack_public_path__ + "assets/audios/94e14634f7ad081cb16bb5e33e2b416a.mp3";